import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { useEffect } from "react";
var AutoPlayContent = function(props) {
    var story = props.story, action = props.action;
    useEffect(function() {
        action("play");
    }, [
        story
    ]);
    var Content = story.originalContent;
    return /*#__PURE__*/ _jsx(Content, _object_spread({}, props));
};
export var tester = function(story) {
    return {
        condition: !!story.content,
        priority: 2
    };
};
export default {
    renderer: AutoPlayContent,
    tester: tester
};
